var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReadyToGo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 2.28125V4.25H7.3125V2.28125C7.3125 2.17188 7.20312 2.0625 7.09375 2.0625H4.90625C4.76953 2.0625 4.6875 2.17188 4.6875 2.28125ZM9.5 4.25C10.457 4.25 11.25 5.04297 11.25 6V12.125C11.25 13.1094 10.457 13.875 9.5 13.875C9.5 14.3672 9.08984 14.75 8.625 14.75C8.13281 14.75 7.75 14.3672 7.75 13.875H4.25C4.25 14.3672 3.83984 14.75 3.375 14.75C2.88281 14.75 2.5 14.3672 2.5 13.875C1.51562 13.875 0.75 13.1094 0.75 12.125V6C0.75 5.04297 1.51562 4.25 2.5 4.25H3.375V2.28125C3.375 1.46094 4.05859 0.75 4.90625 0.75H7.09375C7.91406 0.75 8.625 1.46094 8.625 2.28125V4.25H9.5ZM3.8125 6.875C3.56641 6.875 3.375 7.09375 3.375 7.3125C3.375 7.55859 3.56641 7.75 3.8125 7.75H8.1875C8.40625 7.75 8.625 7.55859 8.625 7.3125C8.625 7.09375 8.40625 6.875 8.1875 6.875H3.8125ZM3.8125 10.375C3.56641 10.375 3.375 10.5938 3.375 10.8125C3.375 11.0586 3.56641 11.25 3.8125 11.25H8.1875C8.40625 11.25 8.625 11.0586 8.625 10.8125C8.625 10.5938 8.40625 10.375 8.1875 10.375H3.8125Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadyToGo);
export default ForwardRef;